import { RequestStatus } from "../../../Enums"
import i18n from '../../../../i18n';

/**
 * 
 * @param {RequestStatus} status 
 * @param {string} approvedByManagerName 
 * @returns {string}
 */
export const GetModifiedBy = (status, approvedByManagerName) => status === RequestStatus.Approved && approvedByManagerName === "" ? i18n.t('employmentBillboard:approvalType.autoApproval') : approvedByManagerName;